import { render, staticRenderFns } from "./EventHistoryBlock.vue?vue&type=template&id=7f51ec0c&scoped=true&"
import script from "./EventHistoryBlock.vue?vue&type=script&lang=js&"
export * from "./EventHistoryBlock.vue?vue&type=script&lang=js&"
import style0 from "./EventHistoryBlock.vue?vue&type=style&index=0&id=7f51ec0c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7f51ec0c",
  null
  
)

export default component.exports